import {Container, Image, Group, ActionIcon, UnstyledButton} from "@mantine/core";
import classes from "./layout.module.css";
import {PiFacebookLogoBold, PiInstagramLogoBold, PiYoutubeLogoBold} from "react-icons/pi";

export function Footer() {
  return (
    <div className="footer">
      <Container size="lg">
        <Group className={classes.links} gap="xl">
          <Image
            src="https://static.digisthesia.com/hexploit/images/logo_hexploit_250.webp"
            w={150}
            h={100}
            me="auto"
          />
          <UnstyledButton component="a" href="https://www.youtube.com/watch?v=iJz5r9GDNXY" target="_blank" c="dimmed">
            Règles en vidéo
          </UnstyledButton>
          <UnstyledButton component="a" href="mailto:team@hexploit.fr" target="_blank" c="dimmed">
            Nous contacter
          </UnstyledButton>
          <Group>
            <ActionIcon
              size="lg"
              color="gray"
              variant="subtle"
              component="a"
              href="https://www.instagram.com/hexploit_game/?hl=fr"
              target="_blank"
              aria-label="Rejoins nous sur instagram"
            >
              <PiInstagramLogoBold size={24} />
            </ActionIcon>
            <ActionIcon
              size="lg"
              color="gray"
              variant="subtle"
              component="a"
              href="https://www.youtube.com/@hexploit_game"
              target="_blank"
              aria-label="Chaine Youtube d'Hexploit"
            >
              <PiYoutubeLogoBold size={24} />
            </ActionIcon>
            <ActionIcon
              size="lg"
              color="gray"
              variant="subtle"
              component="a"
              href="https://www.facebook.com/HexploitGame"
              target="_blank"
              aria-label="Rejoins nous sur facebook"
            >
              <PiFacebookLogoBold size={24} />
            </ActionIcon>
          </Group>
        </Group>
      </Container>
    </div>
  );
}
